<style>
.contenedor {
  display: flex; /* Establece el contenedor como un flex container */
}
.div-debito,
.div-credito {
  width: 50%; /* Cada div ocupa el 50% del ancho del contenedor */
  box-sizing: border-box; /* Incluye el padding y el borde en el ancho total */
  padding: 10px; /* Añade espacio interior al div para mayor claridad */
  /*border: 1px solid #ccc; /* Añade un borde para ver los límites de los div */
}
.opcion {
  display: flex; /* Alinea los elementos del grupo (radio button y comentario) en una fila */
  align-items: flex-start; /* Alinea los elementos del grupo al principio del contenedor */
  margin-bottom: 10px; /* Ajusta el espacio entre las opciones */
}
.radio-input {
  margin-top: 5px; /* Añade un pequeño margen superior al radio button */
}
.comentario {
  font-size: 12px;
  color: #666;
  margin-left: 10px; /* Añade espacio entre el radio button y el comentario */
  margin-top: 0; /* Elimina el espacio superior del comentario */
}
.opcion label {
  margin-bottom: 0; /* Reducir el margen inferior de la etiqueta de la opción */
}
.th-col {
  font-weight: bold;
  background-color: #f2f3f4;
  font-size: 13px;
  padding-top: 6px;
  padding-bottom: 6px;
  border: 1px solid #d6d4d4;
}
.td-item {
  font-size: 13px;
  background-color: gainsboro;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <!-- <b-card-header header-tag="header" class="p-1" role="tab">Plazos de acreditación</b-card-header> -->
      <b-card-body>
        <div
          class="text-center"
          style="font-size: 26px; font-weight:bold; margin-bottom:10px"
        >Plazos de acreditación</div>
        <div
          class="text-center"
          style="margin-bottom:10px"
        >Configurá cuando se acreditan tus operaciones</div>

        <div class="contenedor">
          <div class="div-debito">
            <!-- Contenido del div debito -->
            <div class="text-center">Tarjeta de Débito</div>
            <div class="opcion">
              <input
                type="radio"
                id="opcion1_debito"
                name="opcion_debito"
                value="true"
                v-model="model.CommissionsModel.Debit.Automatic.Enabled"
                class="radio-input"
              />
              <label for="opcion1_debito">
                Automática
                <span style="margin-right:240px"></span>
                {{model.CommissionsModel.Debit.Automatic.Percentage}}%
              </label>
            </div>
            <p class="comentario">{{model.CommissionsModel.Debit.Automatic.Description}}</p>
            <div class="opcion">
              <input
                type="radio"
                id="opcion2_debito"
                name="opcion_debito"
                value="false"
                v-model="model.CommissionsModel.Debit.Automatic.Enabled"
                class="radio-input"
              />
              <label for="opcion2_debito">
                Manual
                <span style="margin-right:265px"></span>
                {{model.CommissionsModel.Debit.Manual.Percentage}}%
              </label>
            </div>
            <p class="comentario">({{model.CommissionsModel.Debit.Manual.Description}})</p>

            <!-- <div v-for="(item,index) in model.automaticDebitComissions" v-bind:key="index">
              <input
                type="radio"
                id="opcion1_debito"
                name="opcion_debito"
                value="true"
                v-model="item.Enabled"
                class="radio-input"
              />
              <label for="opcion1_debito">
                Automática
                <span style="margin-right:240px"></span>
                {{item.Percentage}}%
              </label>
               <p class="comentario">{{item.Description}}</p>
            </div>-->
          </div>
          <div class="div-credito">
            <!-- Contenido del div credito -->
            <div class="text-center">Tarjeta de Crédito</div>
            <div class="opcion">
              <input
                type="radio"
                id="opcion1_credito"
                name="opcion_credito"
                value="true"
                v-model="model.CommissionsModel.Credit.Automatic.Enabled"
                class="radio-input"
              />
              <label for="opcion1_credito">
                Automática
                <span style="margin-right:240px"></span>
                {{model.CommissionsModel.Credit.Automatic.Percentage}}%
              </label>
            </div>
            <p class="comentario">{{model.CommissionsModel.Credit.Automatic.Description}}</p>
            <div class="opcion">
              <input
                type="radio"
                id="opcion2_credito"
                name="opcion_credito"
                value="false"
                v-model="model.CommissionsModel.Credit.Automatic.Enabled"
                class="radio-input"
              />
              <label for="opcion2_credito">
                Manual
                <span style="margin-right:265px"></span>
                {{model.CommissionsModel.Credit.Manual.Percentage}}%
              </label>
            </div>
            <p class="comentario">({{model.CommissionsModel.Credit.Manual.Description}})</p>
          </div>
        </div>

        <div class="text-center">
          <strong>Los valores representan las comisiones de adelanto por día corrido</strong>
          <a @click="getInformacionComisiones()" style="padding: 2px; cursor: pointer;">
            <img src="/img/Informacion.8f90e30c.png" style="width: 20px;height:20px" />
          </a>
        </div>

        <div class="text-center" style="padding-top:10px">
          <b-button class="btn btn-danger" @click="goBack()">
            <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
          </b-button>
          <button class="btn btn-success" type="button" @click="SaveButtonClick()">Guardar</button>
        </div>
      </b-card-body>
    </b-card>
    <modal :show.sync="model.showModalComissions" size="sm">
      <div v-if="model.commissions.length > 0" class="text-center" style="margin: 0px; width: 100%">
        <div class="row">
          <div class="col-4 text-center th-col">Medio de Pago</div>
          <div class="col-3 text-center th-col">Cuotas</div>
          <div class="col-5 text-center th-col">Plazo de Acreditación</div>
        </div>
        <div
          class="row"
          v-for="(itemCommission, index) in this.model.commissions"
          v-bind:key="index"
        >
          <div class="col-4 text-center td-item">{{itemCommission.PaymentMethodName}}</div>
          <div class="col-3 text-center td-item">{{itemCommission.Dues}}</div>
          <div class="col-5 text-center td-item">{{itemCommission.Days}}</div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  data() {
    return {
      model: {
        showModalComissions: false,
        commissions: [],
        automaticComissions: [],
        // automaticCreditComissions: [],
        // automaticDebitComissions: [],

        CreditPaymentMethodID: 0,
        DebitPaymentMethodID: 0,
        CommissionsModel: {
          Debit: {
            Automatic: {
              Id: 0,
              Description: "",
              Percentage: "",
              Enabled: false
            },
            Manual: {
              Description: "Cuando la necesites",
              Percentage: ""
            }
          },
          Credit: {
            Automatic: {
              Id: 0,
              Description: "",
              Percentage: "",
              Enabled: false
            },
            Manual: {
              Description: "Cuando la necesites",
              Percentage: ""
            }
          }
        }
      }
    };
  },
  methods: {
    getInformacionComisiones() {
      let context = this;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetInfoCommissions",
        {},
        context,
        function(response) {
          context.model.commissions = [];
          var PaymentMethodName = "";
          var lastPaymentMethodName = "";
          response.ResponseVM.Items.forEach(x => {
            if (lastPaymentMethodName != x.PaymentMethodName) {
              PaymentMethodName = x.PaymentMethodName;
            } else {
              PaymentMethodName = "";
            }
            var commission = {
              PaymentMethodName: PaymentMethodName,
              Dues: x.Dues,
              CommissionPercentage: x.CommissionPercentage,
              Days: x.Days
            };
            lastPaymentMethodName = x.PaymentMethodName;
            context.model.commissions.push(commission);
          });
          context.model.showModalComissions = true;
        }
      );
    },
    goBack() {
      this.$router.push("AcreditacionesPendientes");
    },
    LoadItemInCommissionsModel(item) {
      let context = this;

      if (item.PaymentMethodID === context.model.CreditPaymentMethodID) {
        context.model.CommissionsModel.Credit.Automatic.Id = item.MethodID;
        context.model.CommissionsModel.Credit.Automatic.Percentage =
          item.Percentage;
        context.model.CommissionsModel.Credit.Manual.Percentage =
          item.PercentageManual;
        context.model.CommissionsModel.Credit.Automatic.Description =
          item.Description;
        context.model.CommissionsModel.Credit.Automatic.Enabled = item.Enabled;
      } else {
        context.model.CommissionsModel.Debit.Automatic.Id = item.MethodID;
        context.model.CommissionsModel.Debit.Automatic.Percentage =
          item.Percentage;
        context.model.CommissionsModel.Debit.Manual.Percentage =
          item.PercentageManual;
        context.model.CommissionsModel.Debit.Automatic.Description =
          item.Description;
        context.model.CommissionsModel.Debit.Automatic.Enabled = item.Enabled;
      }
    },
    GetInfoAutomaticCommissions() {
      let context = this;

      axiosHelpers.axiosGet(
        "OperationsFintouch/GetInfoAutomaticCommissions",
        {},
        context,
        function(response) {
          var Item1 = response.ResponseVM.Items[0];
          var Item2 = response.ResponseVM.Items[1];

          context.LoadItemInCommissionsModel(Item1);
          context.LoadItemInCommissionsModel(Item2);

          context.model.automaticComissions = response.ResponseVM.Items;
          // context.model.automaticCreditComissions = context.model.automaticComissions.filter(
          //   item => item.PaymentMethodID === context.model.CreditPaymentMethodID
          // );
          // context.model.automaticDebitComissions = context.model.automaticComissions.filter(
          //   item => item.PaymentMethodID === context.model.DebitPaymentMethodID
          // );
        }
      );
    },
    SaveButtonClick() {
      let context = this;

      var request = {
        Items: [
          {
            AdvanceConfigurationMethodID: context.model.CommissionsModel.Credit.Automatic.Id,
            Enabled: context.model.CommissionsModel.Credit.Automatic.Enabled
          },
          {
            AdvanceConfigurationMethodID: context.model.CommissionsModel.Debit.Automatic.Id,
            Enabled: context.model.CommissionsModel.Debit.Automatic.Enabled
          }
        ]
      };

      axiosHelpers.axiosPost(
        "OperationsFintouch/SaveAutomaticCommissions",
        request,
        context,
        function(response) {
          if (response.ResponseVM.Result) {
            context.$router.push({
              name: "AcreditacionesPendientes"
            });
          }
        }
      );
    }
  },
  watch: {
    // "model.CommissionsModel.Credit.Automatic.Enabled": function(newValue, oldValue) {
    // }
  },
  beforeMount() {
    let context = this;

    context.model.CreditPaymentMethodID =
      context.$store.getters.ID_CREDIT_PAYMENT_METHOD;
    context.model.DebitPaymentMethodID =
      context.$store.getters.ID_DEBIT_PAYMENT_METHOD;

    context.GetInfoAutomaticCommissions();
  }
};
</script>
      